import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-14 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-115">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-116"></div>

      {/* BADGE — Red, high-attention */}
      <div className="relative bg-badge-red border border-red-400/40 text-white font-black text-[11px] sm:text-sm px-4 py-2 sm:px-5 sm:py-2.5 rounded-full mb-5 sm:mb-7 flex items-center gap-2 shadow-[0_0_25px_rgba(239,68,68,0.4)] uppercase tracking-wide max-w-[95%]" data-id="element-117">
        <span className="w-2 h-2 rounded-full bg-white animate-pulse-composited flex-shrink-0" data-id="element-118"></span>
        <span className="hidden sm:inline" data-id="element-119">
          🚨 DOCENTI DI ARTE STANCHI DI PERDERE SERATE E WEEKEND A PREPARARE LE
          LEZIONI?
        </span>
        <span className="sm:hidden text-[10px] leading-tight" data-id="element-120">
          🚨 STANCHI DI PERDERE SERATE A PREPARARE LE LEZIONI?
        </span>
      </div>

      {/* HEADLINE — Maximum impact */}
      <h1 className="relative font-black text-text-main max-w-4xl mb-4 sm:mb-5 tracking-tight text-[28px] leading-[1.1] sm:text-6xl md:text-7xl sm:leading-[1.05]" data-id="element-121">
        Tutto il tuo anno di{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400 inline-block" data-id="element-122">
          ARTE
        </span>{' '}
        <span className="block mt-1.5 sm:mt-2" data-id="element-123">risolto.</span>
      </h1>

      {/* SUBHEADLINE — Clean and modern */}
      <p className="relative text-text-sec text-base sm:text-xl font-medium leading-relaxed mb-5 sm:mb-7 max-w-3xl mx-auto" data-id="element-124">
        Il sistema{' '}
        <span className="text-orange-400 font-bold" data-id="element-125">"Apri e Insegna"</span> con
        lezioni, verifiche, attività e laboratori pronti per tutte le classi
        della Scuola Media e Superiore.
      </p>

      {/* MICRO BENEFITS — Horizontal */}
      <div className="relative flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-6 sm:mb-8 text-text-main text-xs sm:text-base font-semibold" data-id="element-126">
        <span className="flex items-center gap-1.5" data-id="element-127">
          <span className="text-check-green text-base sm:text-lg" data-id="element-128">✅</span>
          Per Scuola Media e Superiore
        </span>
        <span className="flex items-center gap-1.5" data-id="element-129">
          <span className="text-check-green text-base sm:text-lg" data-id="element-130">✅</span>
          Oltre 1.500 Docenti Soddisfatti
        </span>
        <span className="flex items-center gap-1.5" data-id="element-131">
          <span className="text-check-green text-base sm:text-lg" data-id="element-132">✅</span>
          Accesso Immediato
        </span>
      </div>

      {/* MOCKUP — Larger with soft orange glow */}
      <div className="relative w-full max-w-[300px] sm:max-w-[480px] md:max-w-[575px] mx-auto mb-6 sm:mb-9" data-id="element-133">
        <div className="absolute -inset-8 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(234,88,12,0.25) 0%, transparent 65%)'
      }} aria-hidden="true" data-id="element-134"></div>
        <img src="https://cdn.magicpatterns.com/uploads/mLRj9cVM26KMunVUVEANLr/ChatGPT_Image_28_may_2026,_09_23_54_p.m.-Photoroom.png" alt="Arte Pronta — Kit Scuola Media e Superiore" className="relative w-full h-auto object-contain rounded-2xl drop-shadow-[0_20px_40px_rgba(234,88,12,0.25)]" width={575} height={575} sizes="(max-width: 640px) 300px, (max-width: 768px) 480px, 575px" fetchPriority="high" loading="eager" decoding="async" data-id="element-135" />
      </div>

      {/* SOCIAL PROOF */}
      <div className="relative flex flex-col items-center gap-2.5 mb-6 sm:mb-8" data-id="element-136">
        <div className="flex items-center gap-2" data-id="element-137">
          <span className="text-secondary text-base sm:text-xl" data-id="element-138">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-text-main text-sm sm:text-base font-semibold" data-id="element-139">
            4.9/5{' '}
            <span className="text-text-sec font-medium" data-id="element-140">
              (+500 Recensioni Verificate)
            </span>
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-4 py-1.5 rounded-full border border-secondary/30" data-id="element-141">
          🔥 Oltre 1.500 Docenti hanno già scelto Arte Pronta
        </span>
      </div>

      {/* CTA — The most clickable element */}
      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-3xl px-8 sm:px-16 py-5 sm:py-7 rounded-2xl hover:bg-cta-green-hover hover:scale-[1.02] transition-all inline-block mb-4 sm:mb-5 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_50px_rgba(16,185,129,0.5)] border-2 border-white/20 tracking-tight" data-id="element-142">
        🚀 SÌ! VOGLIO IL KIT COMPLETO
      </a>

      {/* TRUST INDICATORS — More visible */}
      <div className="relative flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-text-main text-xs sm:text-sm font-semibold" data-id="element-143">
        <span className="flex items-center gap-1.5" data-id="element-144">
          <span className="text-base" data-id="element-145">⚡</span> Accesso Immediato
        </span>
        <span className="text-text-sec" data-id="element-146">•</span>
        <span className="flex items-center gap-1.5" data-id="element-147">
          <span className="text-base" data-id="element-148">🛡️</span> Garanzia 7 Giorni
        </span>
        <span className="text-text-sec" data-id="element-149">•</span>
        <span className="flex items-center gap-1.5" data-id="element-150">
          <span className="text-base" data-id="element-151">💳</span> Pagamento Unico
        </span>
      </div>
    </section>;
}